<template>
  <div>
    <h2>材料</h2>

    <Table class="table" :columns="col" :data="data.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="date">
        {{ $moment(row.date).format("YYYY-MM-DD") }}
      </template>
      <template slot-scope="{ row }" slot="file">
        <Button type="primary" size="small" @click="edit(row)">查看</Button>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button
          type="primary"
          style="margin-right: 10px"
          size="small"
          @click="edit(row)"
          >修改</Button
        >
        <Button type="error" size="small" @click="deleteIt(row)">删除</Button>
      </template>
    </Table>

    <Button type="dashed" style="margin-top: 10px" @click="edit({})"
      >添加</Button
    >
    <div class="flex-right" style="margin-top: 10px">
      <Page
        :total="data.total"
        :current="data.page"
        :page-size="data.size"
        @on-change="getData"
      />
    </div>

    <Modal
      v-model="showEdit"
      title="添加/修改"
      @on-ok="save"
      @on-cancel="showEdit = false"
    >
      <Form :model="editObj" label-position="left" :label-width="100">
        <FormItem label="Test Date">
          <DatePicker
            format="yyyy-MM-dd"
            type="date"
            v-model="editObj.date"
            placeholder="选择日期"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem label="Content">
          <i-input type="text" v-model="editObj.content"></i-input>
        </FormItem>
        <FormItem label="files">
          <uploadImg
            :key="editObj._id"
            :srcData="editObj.files"
            @uploadChange="changeImgs"
          ></uploadImg>
        </FormItem>
        <FormItem label="courier">
          <i-switch v-model="editObj.isCourier" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import uploadImg from "@/components/uploadImg.vue";
export default {
  components: { uploadImg },
  data() {
    return {
      col: [
        {
          title: "No.",
          slot: "number",
          align: "center",
          width: 80,
        },
        {
          title: "Content",
          key: "content",
          align: "center",
        },
        {
          title: "file",
          slot: "file",
          align: "center",
        },
        {
          title: "Date",
          slot: "date",
          align: "center",
        },
        {
          title: "Courier",
          key: "isCourier",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      data: {},
      showEdit: false,
      editObj: {},
    };
  },
  methods: {
    async getData(page = 1) {
      let res = await this.api({
        url: "/application_materials/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
        },
      });

      this.data = res;
    },

    changeImgs(val) {
      // console.log(val)
      this.editObj.files = val;
    },

    async save() {
      await this.api({
        url: "/application_materials/save",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
        },
        data: {
          ...this.editObj,
          student_id: this.$store.getters.selectedStudent._id,
          isCourier: this.editObj.isCourier ? 1 : 0,
          date: this.$moment(this.editObj.date).format("YYYY-MM-DD"),
        },
      });
      this.$Message.success("保存成功");
      this.getData();
    },

    edit(val) {
      this.editObj = val;
      this.showEdit = true;
    },
    async deleteIt(item) {
      this.$Modal.confirm({
        title: "确定要删除:" + item.content + "?",
        content: "删除后将不可恢复",
        closable: true,
        cancelText: "取消",
        onOk: async () => {
          await this.api({
            url: "/application_materials/deleteIt",
            method: "delete",
            params: {
              token: this.$store.getters.token,
              ttoken: this.$store.getters.ttoken,
            },
            data: {
              student_id: this.$store.getters.selectedStudent._id,
              _id: item._id,
            },
          });

          this.$Message.success("删除成功");
          this.getData();
        },
        onCancel: () => {},
      });
    },
  },
  mounted() {
    if (!this.$store.getters.selectedStudent._id) {
      return;
    }

    this.getData();
  },

  watch: {
    selectedSchoolSelection_id: function () {
      this.getData();
    },
    "$store.getters.selectedStudent": async function () {
      this.getData();
    },
  },
};
</script>